<template>
  <div id="app">
    <XLoading v-show="isLoading"></XLoading>
    <keep-alive>
      <transition name="slide-fade">
        <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
      </transition>
    </keep-alive>
    <transition name="slide-fade">
      <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import XLoading from '@/components/loading';

  export default {
    name: 'app',
    components: {
      XLoading,
    },
    computed: {
      ...mapGetters(['isLoading']),
    },
  };
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue